import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { ConfigManagerError } from '../../errors/config-manager.error';
import { safeGetPortalId, safeGetProjectName, shallowCopy, getOrCreateFrameId, labelsMapToJsonSerializableRecord, mergeLabelValues } from '../../utils';
import { MAGPIE_CLIENT_LOGGER_NAME } from '../../config/constants';
import { Logger } from 'simple-logging-lib';
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
var _locked = /*#__PURE__*/_classPrivateFieldLooseKey("locked");
var _config = /*#__PURE__*/_classPrivateFieldLooseKey("config");
export class MagpieConfigManager {
  constructor(overrides) {
    this.logger = Logger.getLogger(MAGPIE_CLIENT_LOGGER_NAME);
    Object.defineProperty(this, _locked, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _config, {
      writable: true,
      value: {
        portalId: safeGetPortalId(),
        appName: safeGetProjectName() || 'unknown',
        tags: [],
        labels: new Map(),
        strategy: undefined,
        debug: false,
        forceReload: false,
        onConnectionError: this.logger.error
      }
    });
    this.getConfig = () => shallowCopy(_classPrivateFieldLooseBase(this, _config)[_config]);
    this.getClientMetadata = () => {
      var _this$get;
      return {
        portalId: (_this$get = this.get('portalId')) === null || _this$get === void 0 ? void 0 : _this$get.toString(),
        appName: this.get('appName'),
        tags: this.get('tags'),
        labels: labelsMapToJsonSerializableRecord(this.get('labels')),
        frameId: getOrCreateFrameId()
      };
    };
    _classPrivateFieldLooseBase(this, _config)[_config] = Object.assign({}, _classPrivateFieldLooseBase(this, _config)[_config], overrides);
  }
  static getInstance(overrides = {}) {
    if (!_classPrivateFieldLooseBase(MagpieConfigManager, _instance)[_instance]) {
      _classPrivateFieldLooseBase(MagpieConfigManager, _instance)[_instance] = new MagpieConfigManager(overrides);
    }
    return _classPrivateFieldLooseBase(MagpieConfigManager, _instance)[_instance];
  }
  get(key) {
    // Return a shallow copy if required to prevent direct mutation
    return shallowCopy(_classPrivateFieldLooseBase(this, _config)[_config][key]);
  }
  set(key, value) {
    this.checkLock();
    _classPrivateFieldLooseBase(this, _config)[_config][key] = shallowCopy(value);
  }
  setDebugMode(debugMode) {
    // Allow setting debug mode after the config is locked
    _classPrivateFieldLooseBase(this, _config)[_config].debug = debugMode;
  }
  addTag(tag) {
    this.checkLock();
    if (!_classPrivateFieldLooseBase(this, _config)[_config].tags.includes(tag)) {
      _classPrivateFieldLooseBase(this, _config)[_config].tags = [..._classPrivateFieldLooseBase(this, _config)[_config].tags, tag];
    }
  }
  addLabel(key, values) {
    this.checkLock();
    _classPrivateFieldLooseBase(this, _config)[_config].labels = mergeLabelValues(_classPrivateFieldLooseBase(this, _config)[_config].labels, key, values);
  }
  lock() {
    _classPrivateFieldLooseBase(this, _locked)[_locked] = true;
  }
  checkLock() {
    if (_classPrivateFieldLooseBase(this, _locked)[_locked]) {
      throw new ConfigManagerError(ConfigManagerError.Reason.LOCKED);
    }
  }
  static resetInstance() {
    _classPrivateFieldLooseBase(MagpieConfigManager, _instance)[_instance] = undefined;
  }
}
Object.defineProperty(MagpieConfigManager, _instance, {
  writable: true,
  value: void 0
});